import { t } from "../../components/CustomComponent.js";
import { directionMeta } from "../../components/asset_option.js";

/* ============================================================================
 * ตัวช่วยของหน้ารายละเอียดทรัพย์ — แยกออกมาไว้ที่เดียว เพราะทั้งหัวข้อประกาศ
 * แถบราคา ตารางข้อมูล และการ์ดผู้ติดต่อ ใช้สูตรคิดชุดเดียวกัน
 *
 * ตัวเลขจาก backend อาจมาเป็น string ที่มีคอมมา (เก็บตามที่ผู้ใช้พิมพ์ในฟอร์ม)
 * ทุกฟังก์ชันจึงล้างคอมมาก่อนคำนวณเสมอ
 * ========================================================================== */

export const num = (value) => Number(String(value ?? "").replace(/,/g, "") || 0);

/* 12500 -> "12,500" (ตัดทศนิยมทิ้ง เพราะราคาอสังหาฯ ไม่ใช้สตางค์) */
export const money = (value) => num(value).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const isRent = (deals) => (deals || []).includes("rent");
export const isSale = (deals) => (deals || []).includes("sale");

/* 12 เดือน -> "1 ปี" ให้อ่านง่ายกว่าบอกเป็นเดือนล้วน */
export const monthWord = (month) => {
  const value = num(month);
  if (!value) return "-";
  if (value % 12 === 0) return `${value / 12} ${t("year_unit")}`;
  return `${value} ${t("month_unit")}`;
};

/* ชื่อทิศสำหรับโชว์คู่กับป้าย "ทิศ"
   ไฟล์แปลใส่คำว่า "ทิศ" มาบ้างไม่ใส่บ้าง (dir_north = "ทิศเหนือ" แต่
   dir_northeast = "ตะวันออกเฉียงเหนือ") ตัดคำนำหน้าออกให้เหลือแค่ชื่อทิศ
   จะได้ไม่อ่านเป็น "ทิศ : ทิศเหนือ" */
export const directionWord = (value) => {
  const meta = directionMeta(value);
  return meta ? t(meta.label).replace(/^ทิศ\s*/, "") : "";
};

/* ที่อยู่เต็มตามลำดับไทย : ซอย › แขวง › เขต › จังหวัด › รหัสไปรษณีย์ */
export const fullAddress = (data) =>
  [data.soi, data.subdistrict && `${t("subdistrict_prefix")}${data.subdistrict}`, data.district && `${t("district_prefix")}${data.district}`, data.province, data.postcode]
    .filter(Boolean)
    .join(" ");

/* ลิงก์เปิด Google Maps ตามพิกัดที่แอดมินปักหมุดไว้ */
export const mapLink = (data) =>
  data.latitude && data.longitude
    ? `https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress(data))}`;

/* "ลงประกาศเมื่อ 7 วันที่แล้ว" — 0 วัน = วันนี้ */
export const postedWord = (days) => {
  const value = num(days);
  if (!value) return t("detail_posted_today");
  if (value < 7) return `${value} ${t("detail_days_ago")}`;
  if (value < 30) return `${Math.floor(value / 7)} ${t("detail_weeks_ago")}`;
  return `${Math.floor(value / 30)} ${t("detail_months_ago")}`;
};

/* ค่าใช้จ่ายแรกเข้า = เงินประกัน + ค่าเช่าล่วงหน้า + ค่าเช่าเดือนแรก
   ผู้เช่ามักถามเป็นคำถามแรก จึงคิดให้เลยแทนที่จะให้บวกเอง */
export const moveInTotal = (data) => {
  if (!isRent(data.deals)) return 0;
  const rent = num(data.rent);
  return num(data.deposit) + num(data.advance_month) * rent + num(data.move_in_payment || rent);
};
